import dayjs from 'lib/dayjs';
import Icon from '../AppIcon';

// Small step shown before "Add Log" when an unplanned leave covers several days:
// the log is added for ONE day at a time, the other days stay unplanned and can still be
// requested as leave (or logged separately).
const PickDateModal = ({ isOpen, onClose, dates = [], onSelect, title = 'Select the day' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="w-full max-w-sm rounded-lg bg-white p-5 shadow-xl">
        <div className="mb-1 flex items-center justify-between">
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-gray-500 hover:bg-gray-100"
            aria-label="Close"
          >
            <Icon name="X" size={18} />
          </button>
        </div>
        <p className="mb-4 text-xs text-gray-500">
          Choose the day that was actually worked. The other days stay as unplanned leave and can be
          requested as leave.
        </p>
        <div className="space-y-2">
          {[...dates].sort().map((d) => (
            <button
              key={d}
              type="button"
              onClick={() => onSelect(d)}
              className="flex w-full items-center justify-between rounded-lg border border-gray-200 px-4 py-2.5 text-left text-sm font-medium text-gray-800 hover:border-emerald-500 hover:bg-emerald-50"
            >
              {dayjs(d).format('dddd, DD MMM YYYY')}
              <Icon name="ChevronRight" size={16} className="text-gray-400" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PickDateModal;
